import { getFeatures, FeatureType, BrandingPermission } from "common/features";
import { ds } from "./dataService";

export { FeatureType };

export async function getUserOrgPermissions(orgId) {
    await ds.teams.loadModels();
    let team = ds.teams.defaultTeamForOrg(orgId);

    // Migrate `isSharedThemeRequired` to `brandingPermissions.canAccessCustomThemes`
    if (team.get("isSharedThemeRequired")) {
        await team.update({
            isSharedThemeRequired: null,
            workspaceSettings: {
                brandingPermissions: {
                    customThemes: BrandingPermission.NONE,
                },
            }
        });
    }

    const role = team.getUserRole();
    let workspaceSettings = team.get("workspaceSettings") || {};

    const permissions = getFeatures(role, workspaceSettings);

    return permissions;
}

export async function getUserPlanPermissions() {
    await ds.userPlans.loadModels();
    let role = ds.userPlans.getPersonalPlan();
    let workspaceSettings = {};
    const permissions = getFeatures(role, workspaceSettings);
    return permissions;
}
